/** 订单详情页（pageC/order_detail）业务文案 — 中文 */
export default {
  orderDetail: {
    nav: {
      title: '订单详情',
      tourismTitle: '旅游订单详情',
    },
    common: {
      customerService: '客服',
      copy: '复制',
      orderNo: '订单号',
      orderNoWithColon: '订单号：{orderNo}',
      orderTime: '下单时间：{time}',
      total: '总计',
      yuan: '元',
      loading: '加载中',
      tip: '提示',
      cancel: '取消',
      next: '下一步',
      or: '或单独退订以下产品',
      referenceNote: '*以上信息供您参考',
      updateTime: '更新时间：{time}',
      learnMore: '了解详情',
      mayBeFraud: '可能是诈骗',
      openUrl: '打开网址',
      updatedAt: '更新时间：{time}',
      unionOrderBadge: '联合订单',
      latestTicketTime: '最晚出票时间：{time}',
    },
    payment: {
      payBefore: '请在{time}前完成支付',
      payBeforeShort: '请在{time}前支付',
      lockPriceTip: '完成支付才能锁定价格',
      payNow: '去支付',
      payPending: '待支付',
      paySoonStock: '库存有限请尽快支付，若超时未支付，订单将自动取消',
      orderAmount: '订单金额',
      onlinePay: '在线支付',
      onlinePayLabel: '在线付',
      originalPrice: '原价：￥{amount}',
      payablePrice: '应付价格：￥{amount}',
      orderAmountDetail: '下单明细',
      prepaidAmount: '预付金额',
      refundAmount: '退款金额',
      couponAmount: '优惠券金额',
      appendAmount: '增补金额',
      cancelAmount: '取消金额',
      actualPaid: '实际支付金额',
      pendingAppend: '待补金额',
      totalLabel: '合计',
    },
    unionPoint: {
      title: '云闪付积点抵值',
      usePointNum: '使用积点',
      pointAmount: '积点抵扣',
      pointRefunded: '已返还积点',
      pointCount: '{count} 积点',
      deductAmount: '-￥{amount}',
    },
    coupon: {
      used: '已使用优惠券',
      totalDiscount: '共优惠',
      discountDetail: '优惠券优惠',
      total: '优惠券合计',
      fallback: '优惠券',
      noThreshold: '无门槛',
      fullReduction: '满{minAmount}减{amount}',
      instantReduction: '立减{amount}元',
      fullDiscount: '满{minAmount}享{discount}折',
      percentDiscount: '{discount}折优惠',
    },
    plane: {
      preTravelMustRead: '出行前必读',
      noticeCount: '3条通知',
      civilizedReminder: '文明乘机提醒',
      fraudReminder: '防诈骗提醒',
      luggageRules: '乘机行李规定',
      refundLuggage: '退改签、行李额',
      outbound: '去程',
      return: '返程',
      oneWay: '单程',
      cancelled: '已取消',
      withMeal: '有餐食',
      noMeal: '无餐食',
      stopover: '经停：{city}',
      stopoverTime: '经停时间：{time}',
      travelInfo: '出行信息',
      travelers: '出行人',
      viewId: '查看证件',
      contactPhone: '联系手机',
      changeRejectReason: '改期被拒原因：',
      changeRejectStatus: '改期被拒',
      rebook: '再次预订',
      cancelOrder: '取消订单',
      refundProgress: '退款进度',
      applyRefund: '申请退款',
      issueInvoice: '开发票',
      viewInvoice: '查看发票',
      changeDate: '改期',
      ticketInfo: '出票信息',
      ticketNo: '票号:',
      flightNo: '航班号:',
      refundPassengers: '退票的乘客',
      changePassengers: '改期的乘客',
      flightNoLabel: '航班号:{flightNum}',
      preTravelPopupTitle: '出行前必读',
      flightReminder: '乘机提醒',
      otherReminder: '其他提醒',
      luggageRulesTitle: '乘机行李规定',
      civilizedTitle: '文明乘机提醒',
      fraudTitle: '防诈骗提醒',
      luggageIntro: '乘坐飞机时，哪些物品禁止携带?哪些物品必须托运?哪些物品可以随身携带?',
      civilizedBody:
        '接相关部门通知，在航空器上强占座位、辱骂殴打他人、妨碍机组正常履行职责、霸占航空器、破坏机上设施设备等行为，扰乱公共秩序、危害公共安全。构成违反治安管理行为的，公安机关将依法进行处罚;情节严重的，可能被追究刑事责任。请您遵纪守法、文明乘机。',
      fraudBodyPrefix:
        '凡有冒充航空公司以飞机机械故障，航班取消等为由要求您主动回电、下载其他APP、汇款改签等，',
      fraudBodySuffix:
        '。如需了解航班信息，您可进入0息游机票订单详情页或以航司官网查询为准，如有疑问可联系0息游客服或航司官方客服核实，',
      orderTransaction: '订单交易记录',
      adult: '成人',
      child: '儿童',
      infant: '婴儿',
      planeTicket: '机票',
      airportFee: '机建',
      fuelTax: '燃油',
      changeFee: '改期费用',
      changeDiff: '改期差价',
      priceTimesPerson: '￥{price}×{count}人',
      priceTimesShare: '￥{price}×{count}份',
      unsubscribe: '退订',
      unsubscribePlane: '退订机票',
      unsubscribePlaneDesc: '可一起退订附加产品',
      unsubscribeInsurance: '退订保险',
      fuelOnlyRefund: '只退机建和燃油',
      perPerson: '/人',
      refundReason: '退票',
      statusChanging: '改期中',
      statusRefunded: '已退票',
      statusRefunding: '退票中',
    },
    hotel: {
      cancelRulesBtn: '取消规则',
      viewCancelRules: '查看本单取消规则',
      contactHotel: '联系酒店',
      facilitiesPolicy: '设施·政策',
      map: '地图',
      taxi: '打车',
      checkIn: '入住：{date}',
      checkInAfter: '{time} 后',
      checkOut: '离店：{date}',
      checkOutBefore: '{time} 前',
      roomNights: '{roomName} {roomCount}间{nights}晚',
      maxGuests: '最多可入住{count}人',
      remark: '备注：{remark}',
      cancelPolicy: '取消政策',
      beijingTime: '北京时间',
      cancelFee: '取消费用',
      nonRefundableNotice:
        '若未入住将收取您¥{amount}。订单需等酒店或供应商确认后生效，订单确认结果以0息游短信、通知为准，如订单不确认将全额退款至您的付款账户。',
      refundableNotice: '{rule}，超过后则不可取消，若未入住将收取您￥{amount}。',
      nonRefundable: '不可退订',
      afterBookingSuccess: '预订成功后',
      free: '免费',
      floorSuffix: '层',
      areaSuffix: '㎡',
      breakfastDouble: '双份早餐',
      breakfastNone: '无早餐',
      breakfastSingle: '一份早餐',
      pendingRefundMsgPrefix: '该订单还未订房成功，如若取消订单，可能会产生手续费，可联系客服',
      pendingRefundPhone: '4007659936转1001',
      pendingRefundMsgSuffix: '进行处理',
      confirmRefund: '确认退款',
    },
    tourism: {
      reservationInfo: '预订信息',
      costDetail: '费用明细',
      travelers: '出行人',
      contactInfo: '联系信息',
      validTime: '有效时间',
      bookingCount: '预订份数',
      addonItems: '增值项目',
      bookingPackage: '预订套餐',
      pickupPoint: '上车点',
      dropoffPoint: '下车点',
      pickupWithName: '上车点{name}',
      dropoffWithName: '回程点{name}',
      codeType: '发码类型',
      codeOneOrder: '一单一码',
      codeNone: '无码',
      codePerPerson: '一人一码',
      timeSlot: '时段、场次',
      entryMethod: '入园方式',
      entryQrExchange: '换票入园，持【二维码】先换票在入园',
      entryById: '凭身份证入园',
      entryByPhysical: '凭实体票入园,点击下方物流信息按钮查看物流信息',
      entryByPrint: '凭打印件入园',
      entryByStudentId: '凭学生证入园',
      voucherTitle: '入园凭证',
      voucherKeepSafe: '请妥善保管凭证码',
      voucherNoLeak: '切勿泄露给他人',
      voucherPreventLoss: '以防财产损失',
      voucherCode: '券码：{code}',
      voucherTraveler: '出行人：{name}',
      voucherPackage: '套餐：{planName}',
      copyUrlTip: '请复制网址到浏览器打开',
      qrUrl: '二维码网址：',
      refundNote: '退款说明',
      refundNotSupported: '不支持退款',
      refundSupported: '支持退款',
      refundRuleNotice: '退款说明以当前说明为准',
      viewLogistics: '查看物流',
      logisticsInfo: '物流信息',
      validitySameDay: '购买后{date}当日有效',
      validityUntil: '购买后截止到{date}有效',
      validityRange: '购买后指定日期{start}到{end}内有效',
      productOffShelf: '产品已下架',
    },
    taxi: {
      callPolice: '110报警',
      contactService: '联系客服',
      bookAgain: '再来一单',
      returnTrip: '呼叫返程',
    },
    markup: {
      infoTitle: '加价信息',
    },
    service: {
      purchased: '已购/赠送服务',
      insurance: '保险',
      more: '更多',
    },
    date: {
      today: '今天',
      tomorrow: '明天',
      dayAfterTomorrow: '后天',
      sunday: '周日',
      monday: '周一',
      tuesday: '周二',
      wednesday: '周三',
      thursday: '周四',
      friday: '周五',
      saturday: '周六',
      monthDay: '{month}月{day}日',
    },
    ticketState: {
      deleted: '已删除',
      issued: '已出票',
      refunded: '已退票',
      refunding: '退票中',
      reviewing: '审核中',
      approved: '审核通过',
      reviewFailed: '审核失败',
      pendingChange: '待改期',
      changed: '已改期',
      changeFailed: '改期失败',
      changeCancelled: '改期取消',
      cancelled: '已取消',
      notIssued: '未出票',
    },
    idType: {
      idCard: '居民身份证',
      passport: '护照',
      other: '其它',
      hkmResidence: '港澳台居住证',
      household: '户口簿',
      homeReturn: '回乡证',
      taiwanCompatriot: '台胞证',
      military: '军人证',
      birthCert: '出生证明',
      tourismIdCard: '身份证',
      studentId: '学生证',
      officerId: '军官证',
      householdChild: '户口本(儿童请选择此项)',
      hkmPass: '港澳通行证',
      taiwanMainlandPass: '台湾居民来往大陆通行证',
      taiwanPass: '台湾通行证',
      taiwanEntry: '入台证',
      hkMainlandPass: '香港居民往来内地通行证',
      policeId: '警官证',
      driverLicense: '驾驶证',
      seamanCert: '海员证',
      foreignPermanent: '外国人在中国永久居留证',
      macauMainlandPass: '澳门居民往来内地通行证',
      hkmMainlandPass: '港澳居民来往内地通行证',
      hkmTaiwanPass: '港澳台居民来往内地通行证',
      hkmResidencePermit: '港澳台居民居住证',
      travelPermit: '中华人民共和国旅行证',
      hkIdCard: '香港身份证',
    },
    toast: {
      noChangePassenger: '当前没有能改期的乘客',
      noRefundableTicket: '当前没有可退票的机票',
      refundApplySuccess: '申请退款成功',
      noRefundableFlight: '该订单无可退款的机票',
      changingNoRefund: '改期中不支持退款',
      specialNoRefund: '特殊商品不允许退款',
      productOffShelf: '该产品已下架，无法重新预订',
      productInfoFailed: '获取产品信息失败',
      networkFailed: '网络请求失败，请稍后重试',
      cancelSuccess: '取消成功',
      wrongAccount: '当前订单为非本登录账号订单，请重新登录',
    },
    dialog: {
      cancelOrderMsg: '是否取消订单',
      interceptRefundApplyMsg:
        '提交拦截申请后，若为您拦截成功则会为您进行全额退款，若拦截失败，您可继续出行或重新发起退票申请。',
    },
    mapReferer: '0息游',
  },
  /** 购物车订单详情（pageC/order_detail 页面 type=0） */
  cartOrderDetail: {
    title: '购物车订单详情',
    loading: '加载中…',
    loadError: '订单信息加载失败',
    reload: '重新加载',
    invalidOrder: '订单信息无效',
    // 状态：orderStatus 0-待支付 1-支付中 3-已完成 4-已取消
    statusWaitingPay: '待支付',
    // orderExpires 为负 / 倒计时归零
    statusPayTimeout: '支付超时',
    statusPaying: '支付中',
    statusFinished: '已完成',
    statusCanceled: '已取消',
    // 未知状态兜底
    statusDefault: '订单已提交',
    expireTip: '内完成支付',
    expiredTip: '订单已超时，请重新下单',
    // 金额
    amountGoodsTotal: '商品合计',
    amountDiscount: '优惠',
    amountPayable: '应付总额',
    statusPayAmount: '需付',
    // 订单信息
    infoOrderNo: '订单编号',
    infoCreateTime: '下单时间',
    infoBuyCount: '购买数量',
    infoCombinedPay: '组合支付已付',
    copy: '复制',
    copied: '已复制',
    // 商品
    productCount: '共{n}件商品',
    defaultProductName: '商品',
    // 操作
    payNow: '立即支付',
    cancelOrder: '取消订单',
    cancelConfirmTitle: '取消订单',
    cancelConfirmContent: '确定取消该订单吗？',
    orderCanceled: '订单已取消',
    cancelFail: '取消失败，请稍后重试',
    payFail: '发起支付失败，请稍后重试',
    // 直取支付链接失败（与订单列表 misc.orderPage.toast.cartOrderPayLinkFailed 同文案）
    payLinkFailed: '获取支付链接失败，请稍后重试',
    // 酒店卡片信息行（入住离店行自带措辞，不加行首标签）
    hotelStayRange: '入住 {from} · 离店 {to}',
    hotelGuest: '入住人：',
    hotelPhone: '联系电话：',
    hotelAddress: '地址：',
    // 机票卡片信息行 / 行程
    flightGuest: '乘机人：',
    // 机票费用明细：成人 / 儿童 / 婴儿票价（type 为票种文案），保险兜底名
    flightFareType: '{type}票价',
    flightInsurance: '保险',
    flightTransfer: '中转{n}次',
    flightMultiTrip: '多程',
    // 旅游：specDesc 为空时按购买份数展示
    tourismCount: '{n}份',
    // 旅游卡片信息行（标签自带分隔符，与值同行展示）
    tourismTravelDate: '游玩日期：',
    tourismTravelers: '出行人：',
    tourismContact: '联系人：',
    tourismPhone: '联系手机：',
    tourismPeopleCount: '{n}人',
    // 单价 × 数量
    unitPriceTimesCount: '{price} × {n}',
  },
}
